import React from 'react'

const Home = () => {
  return (
    <>
      HH
    </>
  )
}

export default Home
